import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=531f64cb&scoped=true&"
import script from "./AppLogo.vue?vue&type=script&lang=js&"
export * from "./AppLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f64cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531f64cb')) {
      api.createRecord('531f64cb', component.options)
    } else {
      api.reload('531f64cb', component.options)
    }
    module.hot.accept("./AppLogo.vue?vue&type=template&id=531f64cb&scoped=true&", function () {
      api.rerender('531f64cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/auth/components/AppLogo.vue"
export default component.exports